import { render, staticRenderFns } from "./TheRegistration.vue?vue&type=template&id=1274741d"
import script from "./TheRegistration.vue?vue&type=script&lang=ts"
export * from "./TheRegistration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports